import React, { useCallback, useEffect } from "react";
import { useViewport } from "../../hooks/useViewport";

interface ILoaderContext {
  isLoading: boolean;
  longRespondStatus: boolean;
  handleSetLoading?: (isLoading: boolean, category: ILoaderCategory) => void;
  isWhiteboardMessageLoading?: boolean;
}
export type ILoaderCategory = "app" | "whiteboard" | "whiteboardMessage";
export const loaderContext = React.createContext<ILoaderContext>({
  isLoading: true,
  longRespondStatus: false,
});

export const LoaderProvider = ({ children }: { children: React.ReactNode }) => {
  const [isAppLoading, setIsAppLoading] = React.useState(true);
  const [isWhiteboardLoading, setIsWhiteboardLoading] = React.useState(true);
  const [isWhiteboardMessageLoading, setIsWhiteboardMessageLoading] =
    React.useState(true);
  const [longRespondStatus, setLongRespondStatus] = React.useState(false);
  const isLoading =
    isAppLoading || isWhiteboardLoading || isWhiteboardMessageLoading;

  const { isAppOpened, isStale } = useViewport();

  const handleSetLoading = useCallback(
    (isLoading: boolean, category: ILoaderCategory) => {
      if (category === "app") {
        setIsAppLoading(isLoading);
      } else if (category === "whiteboard") {
        setIsWhiteboardLoading(isLoading);
      } else if (category === "whiteboardMessage") {
        setIsWhiteboardMessageLoading(isLoading);
      } else {
        throw new Error("Invalid category");
      }
    },
    [isAppLoading, isWhiteboardLoading, isWhiteboardMessageLoading]
  );

  //   set longRespondStatus to true after 10 seconds of loading
  useEffect(() => {
    // add condition to prevent longRespondStatus from being set to true when app is not opened
    if (!isAppOpened) return;
    if (isLoading && !isStale) {
      const t = setTimeout(() => {
        setLongRespondStatus(true);
      }, 12000);
      return () => {
        clearTimeout(t);
      };
    } else {
      setLongRespondStatus(false);
    }
  }, [isLoading, isAppOpened, isStale]);

  return (
    <loaderContext.Provider
      value={{
        isLoading,
        longRespondStatus,
        handleSetLoading,
        isWhiteboardMessageLoading,
      }}
    >
      {children}
    </loaderContext.Provider>
  );
};
